<template>
	<div>
	<v-list-item two-line class="px-0">
		<v-list-item-avatar :size="30">
			<v-icon dark color="grey">mdi-bus</v-icon>
		</v-list-item-avatar>
		<v-list-item-content>
			<v-list-item-title>{{ first_line }}</v-list-item-title>
			<v-list-item-subtitle>{{ second_line }}</v-list-item-subtitle>
		</v-list-item-content>
    </v-list-item>
</div>
</template>

<script>
export default {
	props: [
		'item',
	],
	computed: {
		has_lines: function() {
			return this.transport_line != null;
		},
		no_info_text: function() {
			return this.trans(`advert.transport_no_info`);
		},
		transport_mode: function() {
			return this.trans(`advert.transport_mode_walk`);
		},
		transport_duration: function() {
			let duration = _.get(this.$props.item, 'transport_duration', null);
			let suffix = this.trans(`advert.transport_mode_walk`);
			let dur_str = this.trans(`advert.transport_duration_${duration}`);
			return `${duration} ${suffix}`;
		},
		transport_from: function() {
			// 'transport_from_select' => 'Select the type of transport',
			// 'transport_from_bus' => 'Bus stop',
			// 'transport_from_tram' => 'Tram stop',
			// 'transport_from_metro' => 'Metro',
			let type = _.get(this.$props.item, 'transport_from', null);
			return this.trans(`advert.transport_from_${type}`);
		},
		transport_line: function() {
			let line = _.get(this.$props.item, 'transport_line', null);
			if (line == '') return null;
			return line;
		},

		first_line: function() {
			let duration = _.get(this.$props.item, 'transport_duration', null);
			let type = _.get(this.$props.item, 'transport_from', null);
			if (duration && type) {
				return `${this.transport_duration} ${this.transport_from}`;
			}
			return this.no_info_text;
		},
		second_line: function() {
			let lines = this.transport_line ? this.transport_line : this.no_info_text;
			return this.trans(`advert.transport_line`) + ': ' + lines;
		}
	},
}
</script>